module.exports = __webpack_public_path__ + "img/lupa-icon-busca-muestreo.ce9bfcf1.png";